const AUTH_REDIRECT_PARAM_KEYS = ['token', 'redirectUrl', 'referrerUrl'];

const AUTH_ROUTE_PATHS = new Set(['/signin', '/signup', '/signout']);

export const sanitizeHashPath = (pathname: string, search: string): string => {
  const queryParams = new URLSearchParams(search);
  AUTH_REDIRECT_PARAM_KEYS.forEach((key) => queryParams.delete(key));

  const queryString = queryParams.toString();
  return `${pathname}${queryString ? `?${queryString}` : ''}`;
};

const extractHashRoute = (redirectUrl: string): string => {
  if (!redirectUrl) {
    return '';
  }

  if (redirectUrl.startsWith('/')) {
    return redirectUrl;
  }

  if (redirectUrl.includes('#')) {
    return redirectUrl.split('#').pop() ?? '';
  }

  try {
    const parsed = new URL(redirectUrl);
    if (parsed.hash.startsWith('#/')) {
      return parsed.hash.slice(1);
    }
  } catch {
    // Ignore malformed redirect URLs and return no redirect.
  }

  return '';
};

export const toSafeRedirectHashPath = (
  redirectUrl: string | undefined,
  currentHashPath: string,
): string => {
  if (!redirectUrl) {
    return '';
  }

  const routeWithOptionalQuery = extractHashRoute(redirectUrl);
  if (!routeWithOptionalQuery.startsWith('/')) {
    return '';
  }

  const [pathname, rawSearch = ''] = routeWithOptionalQuery.split('?');
  if (AUTH_ROUTE_PATHS.has(pathname)) {
    return '';
  }

  const queryParams = new URLSearchParams(rawSearch);
  AUTH_REDIRECT_PARAM_KEYS.forEach((key) => queryParams.delete(key));

  const queryString = queryParams.toString();
  const sanitizedPath = `${pathname}${queryString ? `?${queryString}` : ''}`;

  return sanitizedPath === currentHashPath ? '' : sanitizedPath;
};
